import script from "./InventoryDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./InventoryDetailModal.vue?vue&type=style&index=0&id=3a20ad2e&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a20ad2e"]])

export default __exports__